<template>
  <div>
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="statusText" slot-scope="scope">
        <el-tag :type="scope.data.statusTextColor">{{ scope.data.statusText }}</el-tag>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          :disabled="scope.data.status != 0"
          v-hasPermi="[authIdentity + ':edit']"
          @click="handleEdit(scope.data, '修改')"
          type="text"
          size="small"
          class="button"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="handleView(scope.data, '查看')"
        >详情</el-button>
        <el-button
          slot="reference"
          :disabled="scope.data.status != 0"
          v-hasPermi="[authIdentity + ':del']"
          class="button"
          type="text"
          size="small"
          @click="handleInitTask(scope.data)"
        >取消任务</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component
        v-if="dialogVisible"
        :ref="currentView"
        :is="currentView"
        :type="type"
        :data="rowData"
      ></component>
      <span slot="footer" v-if="this.type != 'preview'">
        <el-button :disabled="loading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button :loading="loading" class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CONSTANTS from '@/utils/statusConstants'
import { getTaskList, getDropPlantationList, modifyTaskStatus } from '@/api/system/manage'
import { userByRoleList } from '@/api/system/system'
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/detail/interview/components/form' //修改任务
import taskDetail from '@/views/detail/interview/components/detail' //查看详情
import CancelForm from '@/views/pick/taskPick/components/CancelForm'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    taskDetail,
    CancelForm,
  },
  data() {
    return {
      type: '',
      loading: false,
      iLoading: false,
      authIdentity: 'detail:interview',
      dialogVisible: false,
      dialogWidth: '',
      title: '',
      currentView: '',
      colLists: [
        {
          prop: 'userName',
          label: '品控人员',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'visitDueDate',
          label: '走访截止日期',
          isTrue: true,
          width: 110,
        },
        {
          prop: 'plantationNo',
          label: '果园编号',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'locName',
          label: '果园区域',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'visitRequirementDesc',
          label: '走访要求',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'bizNo',
          label: '走访任务单号',
          isTrue: true,
        },
        {
          prop: 'statusText',
          label: '状态',
          isTrue: true,
          formSolt: true,
          width: 80,
        },
        {
          prop: 'visitedDate',
          label: '走访日期',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'readyForHarvest',
          label: '采摘要求是否达标',
          isTrue: true,
          width: 140,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {},
      tableData: [],
      selectOrInputList: [
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'codeBizNo',
          list: [],
          type: 'select',
        },
        {
          model: 'status',
          placeholder: '请选择状态',
          value: 'value',
          label: 'label',
          list: CONSTANTS.taskStatus,
          type: 'select',
        },
        {
          model: 'userId',
          placeholder: '请选择品控人员',
          value: 'id',
          label: 'userName',
          list: [],
          type: 'select',
        },
      ],
      cancelForm: {
        status: 3,
        cancelReason: '',
      },
      cancelRulers: {
        cancelReason: [{ required: true, message: '请输入取消原因', trigger: 'blur' }],
      },

      rowData: {},
    }
  },
  created() {
    this.getDictList({ types: 'landStatus,fertilizerType' })
    this.getDropPlantations()
    this.getUserByRoles()
    this.getList()
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    getDropPlantations() {
      getDropPlantationList().then((res) => {
        if (res.flag) {
          res.data.forEach((item) => {
            item.codeBizNo = item.bizNo + '-' + item.name
          })
          this.selectOrInputList[0].list = res.data
        }
      })
    },
    getUserByRoles() {
      userByRoleList({ roleName: '品控员' }).then((res) => {
        if (res.flag) {
          this.selectOrInputList[2].list = res.data
        }
      })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getTaskList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              item.visible = false
              item.locName = this.formatLocal(item.locDetails, 3)
              item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              item.statusTextColor = CONSTANTS.getStatusConversionColor(item.status, 'taskStatus')
              item.readyForHarvest = CONSTANTS.getStatusConversionForYear(
                item.readyForHarvestStatus,
                'readyForHarvestStatus',
                item.visitedDateTime
              )
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    innerSubmit(row) {
      this.iLoading = true
      this.$refs['cancelForm'].validate(async (valid) => {
        if (valid) {
          this.cancelForm.id = row.id
          let result = await modifyTaskStatus(this.cancelForm)
          this.iLoading = false
          if (result.code == 200 && result.flag) {
            this.$message.success('提交成功')
            this.innerCancel()
            this.getList()
          } else {
            this.$message.error(result.message)
          }
        } else {
          this.iLoading = false
        }
      })
    },
    innerCancel() {
      if (this.iLoading) {
        return
      }
      this.tableData.some((item) => (item.visible = false))
      this.resetForm('cancelForm')
    },
    submitFrom() {
      switch (this.type) {
        case 'cancel':
          this.handleCancelTaskSubmit()
          break
        case 'edit':
          this.handleEditSubmit()
          break
      }
    },
    handleEditSubmit() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.cancel()
          this.getList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    async handleCancelTaskSubmit() {
      this.loading = true
      try {
        const form = await this.$refs[this.currentView].submit()

        let result = await modifyTaskStatus(form)
        if (result.code == 200 && result.flag) {
          this.$message.success('提交成功')
          this.dialogVisible = false
          this.getList()
        } else {
          this.$message.error(result.message)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    cancel() {
      if (this.loading) {
        return
      }
      this.dialogVisible = false
      // this.$refs[this.currentView].reset()
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看走访信息'
      this.currentView = 'taskDetail'
      this.dialogWidth = '60%'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleEdit(row) {
      this.type = 'edit'
      this.title = '修改任务'
      this.currentView = 'myform'
      this.dialogWidth = '60%'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    handleInitTask(row) {
      this.rowData = row
      this.type = 'cancel'
      this.title = '确定取消任务吗？取消后任务作废！'
      this.currentView = 'CancelForm'
      this.dialogWidth = '30%'
      this.dialogVisible = true
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/variables.less';
@import '~@/assets/tableList.less';
.cancelText {
  margin-top: 10px;
}
.cancelInput {
  margin-top: 10px;
}
.line-sm-button {
  border-color: @theme-color;
  background-color: @theme-color;
  border-radius: @btn-radius-size;
  color: #ffffff;
}
.batch-sm-button {
  margin-left: 20px;
  background-color: #ffffff;
  color: #000;
  border-color: #d9d7d7;
  border-radius: @btn-radius-size;
  margin-left: 0;
}
</style>